import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import productApi from 'src/api/product'

export const fetchProductByGroupId = createAsyncThunk(
  'product/fetchProductByGroupId',
  async (groupId) => {
    const response = await productApi.getAllListOfProduct(groupId)
    // console.log("createProductThunk: ", response)
    return response
  }
)

const initialState = {
  isModalOpen: false,
  modalViewName: null,
  modalViewParams: null,
  detail: null,
  reload: false,

  status: '',
  products: [],
  loading: true,
  error: '',
}
const slice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    createProduct(oldState, action) {
      let newProduct = action.payload
      // let products = [...oldState.products];
      oldState.products = [...oldState.products, newProduct]
    },
    deleteProduct(oldState, action) {
      let deleteId = action.payload.productId
      let products = [...oldState.products] //[...oldState,products];
      let index = 0
      products.forEach((product) => {
        if (product.id == deleteId) {
          products.splice(index, 1)
        }
        index++
      })
      oldState.products = products
    },
    setProduct(oldState, action) {
      let newProduct = action.payload
      oldState.products = newProduct
    },
    editProduct(oldState, action) {
      let newProduct = action.payload
      let products = [...oldState.products]
      let index = 0
      products.forEach((product) => {
        if (product.id === newProduct.id) {
          products.splice(index, 1, newProduct)
        }
        index++
      })
      oldState.products = products
    },
    setProductRedux(oldState, action) {
      oldState.detail = action.payload
    },
    openModal(oldState) {
      oldState.isModalOpen = true
    },

    closeModal(oldState) {
      oldState.isModalOpen = false
      oldState.modalViewName = null
      oldState.modalViewParams = null
    },

    setModalViewName(oldState, action) {
      oldState.modalViewName = action.payload
    },

    setModalViewParams(oldState, action) {
      oldState.modalViewParams = action.payload
    },
    setReload(oldState, action) {
      oldState.reload = action.payload
    },
  },

  extraReducers: {
    [fetchProductByGroupId.pending]: (state, action) => {
      state.status = 'loading'
      state.loading = true
    },
    [fetchProductByGroupId.fulfilled]: (state, action) => {
      state.status = 'succeeded'
      state.products = action.payload
      state.loading = false
    },
    [fetchProductByGroupId.rejected]: (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    },
  },
})

export const reducer = slice.reducer

/* Modal */
export const setModalViewName = (viewName) => (dispatch) => {
  dispatch(slice.actions.setModalViewName(viewName))
}

export const setModalViewParams = (params) => (dispatch) => {
  dispatch(slice.actions.setModalViewParams(params))
}

export const openModal = () => (dispatch) => {
  dispatch(slice.actions.openModal())
}

export const closeModal = () => (dispatch) => {
  dispatch(slice.actions.closeModal())
}

export const setReload = (reload) => (dispatch) => {
  dispatch(slice.actions.setReload(reload))
}

/* product dispatch */

export const createProduct = (requestBody) => async (dispatch) => {
  const result = await productApi.addProduct(requestBody)
  dispatch(slice.actions.createProduct(result))
}

export const deleteProduct = (productId) => async (dispatch) => {
  const result = await productApi.deleteProduct(productId)
  // console.log('dispatch 里面deleteid ： ', result, productId)
  dispatch(slice.actions.deleteProduct({ productId }))
}

export const setProduct = (requestBody) => async (dispatch) => {
  const result = await productApi.filterProduct(requestBody)
  // console.log(result.data.data.content)
  dispatch(slice.actions.setProduct(result.data.data.content))
}

export const editProduct = (requestBody) => async (dispatch) => {
  const result = await productApi.editProduct(requestBody)
  dispatch(slice.actions.editProduct(result))
}

export default slice
